import {
  Flex,
  Grid,
  GridItem,
  Heading,
  ModalHeader,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { MODAL_OVERLAY_DARKNESS, SITE_MIN_MARGIN } from "../const";
import { useFilterStore } from "../stores/FilterStore";
import { useCaravanDataContext } from "../CaravanDataContext";
import { capitalize } from "../utils";
import { useAreasModalStore } from "../stores/AreasModalStore";

export const AreaListModal: React.FC<{ forceOpen?: boolean }> = ({ forceOpen }) => {
  const { countyNames } = useCaravanDataContext();
  const { setCounty } = useFilterStore(["setCounty"]);

  const half = Math.ceil(countyNames.length / 2);
  const firstColumn = countyNames.slice(0, half);
  const secondColumn = countyNames.slice(half);

  const { isOpen, onClose } = useAreasModalStore(["isOpen", "onClose"]);

  return (
    <Modal isOpen={forceOpen ? true : isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg={MODAL_OVERLAY_DARKNESS} />
      <ModalContent maxW="400px" borderRadius={0}>
        <ModalHeader borderBottomWidth={1} borderColor="gray.500" p={6}>
          {!forceOpen && <ModalCloseButton size="md" />}
        </ModalHeader>

        <Heading as="h3" size="sm" my={8} textAlign="center">
          Pick an area from the list...
        </Heading>

        <Flex
          flexDir="column"
          width="max-content"
          mx="auto"
          px={SITE_MIN_MARGIN}
          h="max-content"
          borderRadius="15px"
          mb={6}
        >
          <nav>
            <Grid templateColumns="repeat(2, 1fr)" columnGap={20} rowGap={4}>
              <GridItem w="100%">
                {firstColumn.map((county) => (
                  <GridItem
                    key={county}
                    w="100%"
                    textAlign="center"
                    onClick={() => setCounty(county)}
                    color="blue.500"
                    _hover={{ color: "blue.700" }}
                    mb={4}
                  >
                    <Link to={`/areas/${county}`} onClick={onClose}>
                      {capitalize(county)}
                    </Link>
                  </GridItem>
                ))}
              </GridItem>
              <GridItem>
                {secondColumn.map((county) => (
                  <GridItem
                    key={county}
                    w="100%"
                    textAlign="center"
                    onClick={() => setCounty(county)}
                    color="blue.500"
                    _hover={{ color: "blue.700" }}
                    mb={4}
                  >
                    <Link to={`/areas/${county}`} onClick={onClose}>
                      {capitalize(county)}
                    </Link>
                  </GridItem>
                ))}
              </GridItem>
            </Grid>
          </nav>
        </Flex>
      </ModalContent>
    </Modal>
  );
};
